import React, { useState } from 'react'
import './Invoices.css'
import './Timeline.css';
import Layout from '../../../Components/Layout/Layout'
function Invoices() {
    const [choiceType, setChoiceType] = useState(0);
    const [timeItems, setTimeItems] = useState([
        { id: 1, title: 'تایید فاکتور' },
        { id: 2, title: 'آماده سازی و بسته بندی' },
        { id: 3, title: 'ارسال به پست' },
        { id: 4, title: 'تحویل به پست' },
        { id: 5, title: 'تحویل خریدار' },
    ]);
    return (
        <Layout>
            <div className='invoices'>
                <div className="wrraper-invoice-type">
                    <div className={`btn-invoice-type ${choiceType === 1 ? "active" : ""} Under-review`} onClick={
                        () => {
                            setChoiceType(1)
                        }
                    }>
                        <span>در حال ارسال</span>
                    </div>
                    <div className={`btn-invoice-type ${choiceType === 2 ? "active" : ""} Delivered`} onClick={
                        () => {
                            setChoiceType(2)
                        }
                    }>
                        <span>تحویل داده شده</span>
                    </div>
                    <div className={`btn-invoice-type ${choiceType === 3 ? "active" : ""} Cancelled`} onClick={
                        () => {
                            setChoiceType(3)
                        }
                    }>
                        <span>ابطال شده</span>
                    </div>
                </div>
                <div className="wrraper-box-invoices">
                    <div className="invoice-box">
                        <div className="box-item">
                            <div className="shop-name">
                                <span>فروشگاه : </span>
                                <span>برمکیان</span>
                            </div>
                            <div className="invoice-date">
                                <span>تاریخ فاکتور: </span>
                                <span>1404/02/28</span>
                            </div>
                        </div>
                        <div className="box-item">
                            <div className="shop-name">
                                <span>شماره فاکتور : </span>
                                <span>1234</span>
                            </div>
                            <div className="invoice-id">
                                <span>مبلغ: </span>
                                <span>1.555.444 تومان</span>
                            </div>
                        </div>
                        <div className="timeline">
                            {timeItems.map((event, index) => (
                                <div key={index} className="timeline-event">
                                    <div className="line"></div>
                                    {/* <div className="event-dot"></div> */}
                                    <div className="event-title">{event.title}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Invoices